import React, {Component} from 'react'
import {connect} from 'react-redux'
import _ from 'lodash'
import {Field, reduxForm, Form, change} from 'redux-form'
import CustomSelect from "views/Components/CustomSelect.jsx"
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"
//import moment from 'moment'
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// icons
//import PeopleOutline from "@material-ui/icons/PeopleOutline";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import AttachMoney from "@material-ui/icons/AttachMoney";
import AddAlert from "@material-ui/icons/AddAlert";

import {required} from 'views/utils/validations'
import {formatToSelectValues} from 'views/utils/helpers'
import {
  transactionSave,
  transactionsFetch,
  transactionFetch,
} from 'actions/transactions'
import {
  currencyFetch,
  currenciesFetchAll,
  currencyConversion
} from 'actions/currencies'

import {
  danger,
  success,
} from 'actions/notification'

import {
  ibsFetchAll,
  getIbWithdrawalBalance,
  ibFetch,
  ibFilter
} from 'actions/ibs'

import {
  accountsFetchAll
} from 'actions/accounts'
import {
  clientsFetchAll
} from 'actions/clients'

import {
  plaformsFetch,
  plaformFilter
} from 'actions/platforms'
import {
  transactionDestination,
} from 'enums'


const validate = values => {

 const errors = {}

 const requiredFields = [

 'ibId',
 'currencyId',
 'amount',

 ]

 if (!values.amount) {
    errors.amount = 'Required'
  } else if (!/^[0-9]\d*(\.\d+)?$/g.test(values.amount)) {
             
    errors.amount = 'Invalid Number for Amount'
  }

 requiredFields.forEach(field => {

 if (!values[field]) {

 errors[field] = 'Required'

 }

 })

 

 return errors

}

const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined
const minValue = min => value =>
  value && value < min ? `Value must be at least ${min}` : undefined
const minValue1 = minValue(1)

/*const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined

const maxValue = max => value =>
  value && value > max ? `Must be less than ${max}` : undefined*/


class CreateWithdrawal extends Component {
    state = {
      ibList:[],
      amount: 0,
      amountUSD: 0,
      maxAmountUSD: 0,
      maxAmount: 0,
      selectedIb: {tradingAccounts: [], bankAccounts: []},
      selectedCurrency: {},
      withdrawalBalanceUSD: 0,
      exchange_rate: 1,
      clientTradingAccounts: [],
      tr: false,
      bc: false,
    }


    componentWillMount(){
    this.amountChange = this.amountChange.bind(this)
    }
    componentDidMount(){
      this.props.ibsFetchAll().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

    });
      
      this.props.plaformFilter({size: 10000000})
      this.props.plaformsFetch()
      //this.props.change('amount', 0);
      //this.props.change('amountUSD', 0);
      //this.props.change('exchange_rate', 0);
      //this.props.currenciesFetch();
      this.props.currenciesFetchAll();
    }
    getInput(data) {
      return <Field
              name={data.key}
              placeholder={data.name}
              id={data.key}
              icon={data.icon}
              type={data.type}
              props={{
                name: data.key
              }}
              validate={data.validate ? data.validate : []}
              component={ValidatedCustomInput}
              /*disabled={data.disabled}
              readonly={data.readonly}*/
            />
    }
    getInputNumber(data) {
      return <Field
              name={data.key}
              placeholder={data.name}
              id={data.key}
              icon={data.icon}
              type="number"
              props={{
                name: data.key
              }}
              validate={data.validate ? data.validate : []}
              component={ValidatedCustomInput}
              max={0}
              min={0}
              /*disabled={data.disabled}
              readonly={data.readonly}*/
            />
    }


    ibChange(ev) {
     
      
      const ib = ev.target.value
      //const time = moment(new Date()).subtract(1,'months').endOf('month').format()
      this.props.ibFetch(ib).then((ib) => {
        this.setState({...this.state, selectedIb: ib})
        this.props.change('destination', 0)
      })

      //let initialAmount = 0;

      /*this.props.getIbBalance(ib, Date.parse(time)).then((balance) => {
        
        initialAmount = balance.balance;
        
        this.setState({...this.state, amount: (initialAmount-1)})
        //this.props.change('amount', 0);
        
        this.setState({...this.state, amountUSD: balance.balance})
        //this.props.change('amountUSD', balance.balance);
        
        this.setState({...this.state, maxAmount: balance.balance})
        //this.props.change('maxAmount', balance.balance);

        this.setState({...this.state, maxAmountUSD: balance.balance})
        //this.props.change('maxAmountUSD', balance.balance);

      })*/
      
      this.props.getIbWithdrawalBalance(ib).then((balance) => {
        
        this.setState({...this.state, maxAmountUSD: balance.totalBalance})
        this.setState({...this.state, withdrawalBalanceUSD: balance.withdrawalBalance})
        

        if (this.state.amount>0) {

          this.setState({...this.state, amount: balance.withdrawalBalance})
          //this.setState({...this.state, amount: (initialAmount - balance.withdrawalBalance)})
          //this.props.change('amount', (initialAmount - balance.withdrawalBalance));
          
          this.setState({...this.state, amountUSD: balance.withdrawalBalance})
          //this.setState({...this.state, amountUSD: (initialAmount - balance.withdrawalBalance)})
          //this.props.change('amountUSD', (initialAmount - balance.withdrawalBalance));
          
          this.setState({...this.state, maxAmount: balance.withdrawalBalance})
          //this.setState({...this.state, maxAmount: (initialAmount - balance.withdrawalBalance)})
          //this.props.change('maxAmount', (initialAmount - balance.withdrawalBalance));

          this.setState({...this.state, maxAmountUSD: balance.withdrawalBalance})
          //this.setState({...this.state, maxAmountUSD: (initialAmount - balance.withdrawalBalance)})
          //this.props.change('maxAmountUSD', (initialAmount - balance.withdrawalBalance));
        }
        //this.props.change('amountUSD', 0);

      })


    }
    currencyChange(ev) {

      /*console.log('this.state.amount',this.state.amount);
      console.log('this.props.amount',this.props.amount);
      console.log('this.state.amountUSD',this.state.amountUSD);
      console.log('this.props.amountUSD',this.props.amountUSD);
      console.log('this.state.maxAmount',this.state.maxAmount);
      console.log('this.props.maxAmount',this.props.maxAmount);
      console.log('this.state.maxAmountUSD',this.state.maxAmountUSD);
      console.log('this.props.maxAmountUSD',this.props.maxAmountUSD);*/
      
      const currency = ev.target.value
      
      this.props.currencyFetch(currency).then((currency) => {
        this.setState({...this.state, selectedCurrency: currency})
      })

      //let maxAmount = (Math.floor(this.state.maxAmount) - Math.floor(this.state.withdrawalBalanceUSD))
      //let maxAmountUSD = (Math.floor(this.state.maxAmountUSD) - Math.floor(this.state.withdrawalBalanceUSD))
      let maxAmount = Math.floor(this.state.withdrawalBalanceUSD);
      let maxAmountUSD = Math.floor(this.state.withdrawalBalanceUSD);
      let existingAmount = Math.floor(this.state.amount);
      
      if (parseInt(maxAmount,10)<=0) {
        maxAmount = Math.floor(this.state.maxAmount);        
        maxAmountUSD = Math.floor(this.state.maxAmountUSD);        
      }


      this.props.currencyConversion(1, currency).then((result) => {

        if (parseFloat(result.rate)>0) {
          let convertedValue = (result.rate/1)*maxAmount;
          //let existingConvertedValue = Math.floor((result.rate/1)*existingAmount);

          this.setState({...this.state, exchange_rate: (result.rate/1)})

          this.setState({...this.state, amountUSD: (1/result.rate)*existingAmount})
          
          /*if (existingAmount<=0)
          {
            this.props.change('amount', maxAmount);
            this.setState({...this.state,amount: maxAmount});
            this.props.change('amountUSD', maxAmount);
            this.setState({...this.state,amountUSD: maxAmount});
          } else {*/
            this.setState({...this.state,maxAmount: Math.floor(convertedValue)});
            this.props.change('maxAmount', Math.floor(convertedValue));
            this.props.change('amount', Math.floor(convertedValue));
            this.setState({...this.state,amount: Math.floor(convertedValue)});
            this.props.change('amountUSD', Math.floor(this.state.amount*(1/result.rate)));
            this.setState({...this.state,amountUSD: Math.floor(this.state.amount*(1/result.rate))});
          //}
          
          //this.props.change('amountUSD', Math.floor((1/result.rate)*existingAmount));
          
        }
      })

      //this.props.change('amountUSD', maxAmountUSD);

      /*console.log('AFTER this.state.amount',this.state.amount);
      console.log('AFTER this.props.amount',this.props.amount);
      console.log('AFTER this.state.amountUSD',this.state.amountUSD);
      console.log('AFTER this.props.amountUSD',this.props.amountUSD);
      console.log('AFTER this.state.maxAmount',this.state.maxAmount);
      console.log('AFTER this.props.maxAmount',this.props.maxAmount);
      console.log('AFTER this.state.maxAmountUSD',this.state.maxAmountUSD);
      console.log('AFTER this.props.maxAmountUSD',this.props.maxAmountUSD);*/
      
    }
    amountChange(e) {

      /*console.log('this.state.amount',this.state.amount);
      console.log('this.state.amountUSD',this.state.amountUSD);
      console.log('this.state.maxAmount',this.state.maxAmount);
      console.log('this.state.maxAmountUSD',this.state.maxAmountUSD);*/

      e.min = (Math.floor(this.state.maxAmount)>1)? 1:0;
      e.max = (Math.floor(this.state.maxAmount) - Math.floor(this.state.withdrawalBalanceUSD));
      
      let amount = e.target.value
      let maxAmount = (Math.floor(this.state.maxAmount) - Math.floor(this.state.withdrawalBalanceUSD))

      if (parseInt(maxAmount,10)<=0) {
        maxAmount = Math.floor(this.state.maxAmount);        
      }

      if ((parseInt(e.target.value,10)>=1) && (parseInt(e.target.value,10)<=maxAmount)) {
      
        this.setState({...this.state,amount: e.target.value});
        this.props.change('amount', e.target.value);
        this.setState({...this.state, amountUSD: parseFloat((1/this.state.exchange_rate)*e.target.value).toFixed(2).toString()});
        this.props.change('amountUSD', parseFloat((1/this.state.exchange_rate)*e.target.value).toFixed(2).toString());

      } else if (parseInt(e.target.value,10)<=0) {
        
        amount = 0;
        this.setState({...this.state,amount: amount});
        this.props.change('amount', amount);
        this.setState({...this.state, amountUSD: 0});
        this.props.change('amountUSD', 0);
        this.showNotification("bc");
        
      } else if (parseInt(e.target.value,10)>maxAmount) {
        
        amount = parseInt(Math.floor(this.state.maxAmount),10);
        this.setState({...this.state, amount: amount});
        this.props.change('amount', amount);
        
        this.setState({...this.state, amountUSD: parseFloat((1/this.state.exchange_rate)*amount).toFixed(2).toString()});
        this.props.change('amountUSD', parseFloat((1/this.state.exchange_rate)*amount).toFixed(2).toString());
        this.showNotification("tr");
      }

      
    }

    handleChange = name => event => {
      this.setState({ [name]: event.target.value });
    };
    destinationChange(ev){
      const destination = ev.target.value
      const {selectedIb} = this.state
      if(destination === 'BANK_ACCOUNT') {
        if(selectedIb.bankAccounts.length !== 0) {
          this.props.change('bankAccountId', selectedIb.bankAccounts[0].bankAccountId)
          this.props.change('tradingAccountId', 0)
        } else {
          this.props.change('bankAccountId', 0)
        }
      } else if (destination === 'TRADING_ACCOUNT'){
        if(selectedIb.tradingAccounts.length !== 0) {
          this.props.change('tradingAccountId', selectedIb.tradingAccounts[0].tradingAccountId)
          this.props.change('bankAccountId', 0)
        } else {
          this.props.change('tradingAccountId', 0)
        }
      } else {
        
        this.props.accountsFetchAll( null, this.state.selectedIb.ibId , null).then((resultAccounts) => {
          
          resultAccounts.content = this.filterClientAccountNumbers(resultAccounts.content);

          this.props.clientsFetchAll(this.state.selectedIb.ibId ,null, null).then((resultClients) => {

            let merged = [];

            for(let i=0; i<resultAccounts.content.length; i++) {
              merged.push({
               ...resultAccounts.content[i], 
               ...(resultClients.content.find((itmInner) => itmInner.clientId === resultAccounts.content[i].clientId))}
              );
            }

            merged = this.filterClientAccountNumbers(merged);

            this.setState({...this.state,clientTradingAccounts: merged});

          })
        })



        this.props.change('bankAccountId', 0)
        this.props.change('tradingAccountId', 0)
      }
    }
    handleSliderChange(value) {
      this.props.change('amount', value)
    }

    filterClientAccountNumbers(arrAccounts) {
      
          
          arrAccounts = this.getUniqueArrayValues(arrAccounts,'number');
          arrAccounts.splice(_.findIndex(arrAccounts, function(item) {
              return item.number === '99999900009999';
          }), 1);
          arrAccounts.sort(function(obj1, obj2) {
            // Ascending: first age less than the previous
            return obj1.accountId - obj2.accountId;
          });

          return arrAccounts;
    }

    getUniqueArrayValues(arr, comp) {

      const unique = arr
           .map(e => e[comp])

         // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)

        // eliminate the dead keys & store unique objects
        .filter(e => arr[e]).map(e => arr[e]);

       return unique;
    }

    renderDestinationFields(){
      const {withdrawalForm, platforms} = this.props
      const {selectedIb, clientTradingAccounts} = this.state
      const destination = withdrawalForm && withdrawalForm.values ? withdrawalForm.values.destination : '' 

      
      switch (destination) {
        case 'CLIENT_TRADING_ACCOUNT':
          return (
            <div>
                
                <Field
                  name="clientTradingAccountNumber"
                  options={clientTradingAccounts.map((i) => {return {value: i.number, label: `${i.number} ( ${i.name} )` }})}
                  placeholder="Clıent Trading Accounts"
                  id="clientTradingAccountNumber"
                  props={{
                    name:"clientTradingAccountNumber"
                  }}
                  validate={[required]}
                  component={CustomSelect}
                />

                <Field
                  name="clientTradingAccountPlatformId"
                  options={platforms.map((i) => {return {value: i.platformId, label: i.name}})}
                  placeholder="Clıent Trading Account Platform *"
                  id="clientTradingAccountPlatformId"
                  props={{
                    name:"clientTradingAccountPlatformId"
                  }}
                  validate={[required]}
                  component={CustomSelect}
                />
            </div>
          )
        case 'TRADING_ACCOUNT':
          return (
            <div>
                <Field
                  name="tradingAccountId"
                  options={selectedIb.tradingAccounts.map((i) => {return {value: i.tradingAccountId, label: `${i.number}`}})}
                  label="Trading Account Id *"
                  hidePlaceholderInMenu={true}
                  canHaveZeroValue={true}
                  id="tradingAccountId"
                  props={{
                    name:"tradingAccountId"
                  }}
                  validate={[required]}
                  component={CustomSelect}
                />
            </div>
          )
        case 'BANK_ACCOUNT':
          return (
            <div>
                <Field
                  name="bankAccountId"
                  options={selectedIb.bankAccounts.map((i) => {return {value: i.bankAccountId, label: `${i.bankName} - ${i.beneficiaryIban}`}})}
                  label="Bank Account Id *"
                  hidePlaceholderInMenu={true}
                  canHaveZeroValue={true}
                  id="bankAccountId"
                  props={{
                    name:"bankAccountId"
                  }}
                  validate={[required]}
                  component={CustomSelect}
                  
                />
            </div>
          )
        default:
          break
      }
    }

    submit(values){

      if (parseInt(values.amountUSD,10)<=parseInt(this.state.maxAmountUSD,10)) {
        
      this.props.save(values)
        .then(e=>{
          this.props.success(e.withdrawalId + ' Added',4)
          this.props.fetchAll()
          this.props.history.goBack()
        })
        .catch(e=>{this.props.danger(e+'',4);})

      } else {
        this.showNotification("tr");
        //throw new Error();
      }

    }

    showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        6000
      );
    }
  }

    render(){
    const {classes, ibs, handleSubmit,currencies} = this.props
    const {maxAmount,maxAmountUSD,amount,amountUSD,withdrawalBalanceUSD,ibList} = this.state
    
    return(
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(this.submit.bind(this))}>
                <GridContainer justify="center">

                  <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                      Create Withdrawal
                    </h4>
                  </GridItem>
                  
                  <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="ibId"
                      options={ibList.map((i) => {return {value: i.ibId, label: `${i.firstName} ${i.lastName} (${i.ibId})`}})}
                      placeholder="IB *"
                      id="ibId"
                      props={{
                        name:"ibId"
                      }}
                      onChange={(ev) => this.ibChange(ev)}
                      validate={[required]}
                      component={CustomSelect}
                    />
                    {maxAmountUSD !== 0 &&
                      <label><h5>{`Current Balance (USD) : ${maxAmountUSD.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`}</h5></label>
                      /*<Field
                        name="maxAmount"
                        label={`Current Balance (USD) : ${this.state.maxAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`}
                        id="maxAmount"
                        props={{
                          name:"maxAmount",
                        }}
                        max={this.state.maxAmount+(this.state.maxAmount*0.75)}
                        min={0}
                        validate={[required]}
                        component={CustomSlider}
                        disabled={true}
                      ></Field>*/
                      
                    }
                    {withdrawalBalanceUSD !== 0 &&
                      <label><h5>{`Widthdrawal Balance (USD) : ${withdrawalBalanceUSD.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`}</h5></label>
                    }
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="currencyId"
                      options={currencies.map((i) => {return {value: i.currencyId, label: `${i.name} (${i.currencyId})`}})}
                      placeholder="Currency *"
                      id="currencyId"
                      props={{
                        name:"currencyId"
                      }}
                      onChange={(ev) => this.currencyChange(ev)}
                      validate={[required]}
                      component={CustomSelect}
                    />
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    {<label><h5>{`Enter Amount :`}</h5></label>}
                    {<Field
                        type="number"
                        id="amount"
                        name="amount"
                        label={<h5>`Enter Amount :`</h5>}
                        placeholder={""}
                        props={{
                          id:"amount",
                          name:"amount",
                          /*onChange:(ev) => this.amountChange(ev),*/
                          value:amount,
                          min:0,
                        }}
                         inputProps={{
                          id:"amount",
                          name:"amount",
                          /*onChange:(ev) => this.amountChange(ev),*/
                          value:amount
                        }}
                        max={Math.floor(maxAmount)}
                        min={1}
                        icon={<SwapHoriz className={this.props.classes.inputAdornmentIcon}/>}
                        /*onChange={this.amountChange.bind(this)}*/
                        onChange={(ev) => this.amountChange(ev)}
                        value={amount}
                        //onChange={this.handleSliderChange.bind(this)}
                        validate={[required,number, minValue1]}
                        disabled={false}
                        component={ValidatedCustomInput}
                      ></Field>}
                      <Snackbar
                        place="bc"
                        color="warning"
                        icon={AddAlert}
                        message="The transaction amount cannot be less than zero."
                        open={this.state.bc}
                        closeNotification={() => this.setState({ bc: false })}
                        close
                      />
                      <Snackbar
                        place="tr"
                        color="danger"
                        icon={AddAlert}
                        message="The transaction amount cannot be more than the current balance."
                        open={this.state.tr}
                        closeNotification={() => this.setState({ tr: false })}
                        close
                      />
                      </GridItem>
                    

                    
               
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    {<Field
                        type="text"
                        id="amountUSD"
                        name="amountUSD"
                        label={`<h6>Enter Amount :</h6>`}
                        placeholder={'Amount in USD based on current exchange rate ('+this.state.exchange_rate+')'}
                        props={{
                          name:"amountUSD",
                          readOnly:true,
                          min:0,
                        }}
                        inputProps={{
                          id:"amountUSD",
                          name:"amountUSD",
                        }}
                        max={Math.floor(maxAmount)}
                        min={1}
                        icon={<AttachMoney className={this.props.classes.inputAdornmentIcon}/>}
                        value={Math.floor(amountUSD)}
                        validate={[required]}
                        component={ValidatedCustomInput}
                      ></Field>}
                      </GridItem>
                 
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="destination"
                      options={formatToSelectValues(transactionDestination)}
                      placeholder="Destination *"
                      id="destination"
                      props={{
                        name:"destination",
                      }}
                      onChange={(ev) => this.destinationChange(ev)}
                      validate={[required]}
                      component={CustomSelect}
                    />

                    {this.renderDestinationFields()}

                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={10}>
                      <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                  </GridItem>
                </GridContainer>
              </Form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      )
  }
}

function mapStateToProps(state) {
  return {
    ibs: state.ibs.list,
    currencies: state.currencies.list,
    platforms: state.platforms.list,
    withdrawalForm: state.form.createCreateWithdrawalForm
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetch:(id)=>dispatch(transactionFetch(id)),
    fetchAll:() => dispatch(transactionsFetch()),
    save:(data)=>dispatch(transactionSave(data)),
    danger:(text,sec)=>dispatch(danger(text,sec)),
    success:(text,sec)=>dispatch(success(text,sec)),
    ibsFetchAll: () => dispatch(ibsFetchAll()),
    ibFilter: (filter) => dispatch(ibFilter(filter)),
    plaformsFetch: () => dispatch(plaformsFetch()),
    ibFetch: (ib) => dispatch(ibFetch(ib)),
    plaformFilter: (filter) => dispatch(plaformFilter(filter)),
    getIbWithdrawalBalance: (id) => dispatch(getIbWithdrawalBalance(id)),
    change: (field, value) => dispatch(change('createCreateWithdrawalForm', field, value)),
    //currenciesFetch:() => dispatch(currenciesFetch()),
    currencyFetch:(currency) => dispatch(currencyFetch(currency)),
    currenciesFetchAll:() => dispatch(currenciesFetchAll()),
    currencyConversion: (native_currency_id,foreign_currency_id) => dispatch(currencyConversion(native_currency_id,foreign_currency_id)),
    clientsFetchAll: (ibid, profileid, clientName) => dispatch(clientsFetchAll(ibid, profileid, clientName)),
    accountsFetchAll: (clientId, ibId, query) => dispatch(accountsFetchAll(clientId, ibId, query))
  }
}

// export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createCreateWithdrawalForm' })(CreateWithdrawal)))
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createCreateWithdrawalForm', validate })(CreateWithdrawal)))



// WEBPACK FOOTER //
// ./src/views/Transactions/CreateWithdrawal.jsx